// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__mxd26","validationTips":"StatementDescriptor_validationTips__1w69U"};